export default __webpack_public_path__ + "static/media/detail_mobile_14_1.c0e688ae.jpg";